import React from "react";
import TableLabel from "src/components/label/TableLabel";
import Tab from "src/components/ui/Tab";
import DateButton from "src/components/button/DateButton"

interface TableTitlelProps {
    name: string;
    date?: string;
    modalData?: {
        title: string;
        content: string[];
    };
    tabs?: string[];
    dateBtn?: string;
    type?: string;
    onDateChange?: (newDate: string) => void;
}

const TableTitle: React.FC<TableTitlelProps> = ({ name, date, modalData, tabs, dateBtn, type, onDateChange }) => {
    return (
        <div className="d-flex justify-content-between title align-items-center pt-4 pb-3">
            <TableLabel name={name} date={date} modalData={modalData} />
            {tabs && <Tab tabs={tabs} type={type} />}
            {dateBtn && <DateButton todayDate={dateBtn} onDateChange={onDateChange} />}
        </div>
    );
};

export default TableTitle;
